import { useState, useEffect } from 'react';

const usePageLoad = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if page is already loaded
    const checkPageLoaded = () => {
      if (document.readyState === 'complete') {
        setIsLoading(false);
        return true;
      }
      return false;
    };

    // If page is already loaded, hide loader immediately
    if (checkPageLoaded()) {
      return;
    }

    const handleLoad = () => {
      // Small delay for smooth transition
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    };

    const handleError = () => {
      // Even if there are errors, hide loader after a timeout
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    };

    // Add event listeners
    window.addEventListener('load', handleLoad);
    window.addEventListener('error', handleError, true);

    // Fallback timeout - hide loader after 5 seconds max
    const fallbackTimer = setTimeout(() => {
      console.log('Fallback: Hiding loader after timeout');
      setIsLoading(false);
    }, 5000);

    // Cleanup function
    return () => {
      window.removeEventListener('load', handleLoad);
      window.removeEventListener('error', handleError, true);
      clearTimeout(fallbackTimer);
    };
  }, []);

  return isLoading;
};

export default usePageLoad;